

type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function GiftIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            onClick={() => action && action()
            }

            width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.21875 1.43628L8 2.71753L8.75 1.43628C9.25 0.561279 10.1562 0.0300293 11.1562 0.0300293H11.25C12.75 0.0300293 14 1.28003 14 2.78003C14 3.24878 13.875 3.65503 13.6875 4.03003H14.5C15.3125 4.03003 16 4.71753 16 5.53003V7.53003C16 8.18628 15.5625 8.74878 15 8.96753V9.03003V14.03C15 15.155 14.0938 16.03 13 16.03H3C1.875 16.03 1 15.155 1 14.03V9.03003V8.96753C0.40625 8.74878 0 8.18628 0 7.53003V5.53003C0 4.71753 0.65625 4.03003 1.5 4.03003H2.28125C2.09375 3.65503 2 3.24878 2 2.78003C2 1.28003 3.21875 0.0300293 4.75 0.0300293H4.8125C5.8125 0.0300293 6.71875 0.561279 7.21875 1.43628ZM14.5 5.53003H11.25H9V7.53003H13.5H14.5V5.53003ZM7 5.53003H4.75H1.5V7.53003H2.5H7V5.53003ZM7 9.03003H2.5V14.03C2.5 14.3113 2.71875 14.53 3 14.53H7V9.03003ZM9 14.53H13C13.25 14.53 13.5 14.3113 13.5 14.03V9.03003H9V14.53ZM11.25 4.03003C11.9375 4.03003 12.5 3.49878 12.5 2.78003C12.5 2.09253 11.9375 1.53003 11.25 1.53003H11.1562C10.6875 1.53003 10.2812 1.78003 10.0312 2.18628L8.9375 4.03003H9H11.25ZM7 4.03003H7.03125L5.9375 2.18628C5.71875 1.78003 5.28125 1.53003 4.8125 1.53003H4.75C4.03125 1.53003 3.5 2.09253 3.5 2.78003C3.5 3.49878 4.03125 4.03003 4.75 4.03003H7Z" fill="#6E7586"/>
            </svg>)


}